import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {Machines} from "../../machines/Machines";
import {FormControlLabel} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import {Machine} from "../../../models/machine.models";
import React, {Fragment, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {searchOrganizationMachines} from "../../../api/machine-functions";
import {httpPost} from "../../../api/http-functions";

const useStyles = makeStyles((theme) => ({
    selectedCount: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    }
}));

const SelectMachines = (props: {selectedMachines: Machine[], setSelectedMachines: (arg0: Machine[]) => void, organizationId: string | null}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [allMachinesSelected, setAllMachinesSelected] = useState<boolean>(false);

    const selectAllMachines = async (machines: Machine[], page: number = 0, size: number = 100): Promise<Machine[]> => {
        const currentPage = await searchOrganizationMachines(httpPost)({organizationId: props.organizationId && parseInt(props.organizationId) || undefined, size: 100, page: 0, filter: ""});
        const total = currentPage.total;
        const currentMachines = [...machines, ...currentPage.items];

        if (total > size * (page + 1)) {
            return selectAllMachines(currentMachines, page + 1, size);
        } else {
            return currentMachines;
        }
    };

    const onSelectAllMachineChange = async (e: any) => {
        const checked = e.target.checked;
        if (checked) {
            const result = await selectAllMachines([]);
            props.setSelectedMachines(result);
            setAllMachinesSelected(true);
        } else {
            props.setSelectedMachines([]);
            setAllMachinesSelected(false);
        }
    }

    const onSelectMachine = (machine: Machine, e: any) => {
        const checked = e.target.checked;
        if (!checked) {
            props.setSelectedMachines(props.selectedMachines.filter(m => m.id !== machine.id));
        } else {
            props.setSelectedMachines([...props.selectedMachines, machine]);
        }
    };

    return <Fragment>
        <Grid item xs={12} className={classes.selectedCount}>
            <Typography variant="subtitle1">
                {t('Machine.MoveMachines.Tabs.SelectMachines.Selected', {count: props.selectedMachines.length})}
            </Typography>
        </Grid>
        <Machines organizationId={props.organizationId}
                  actionForAll={<Grid item xs={12}><FormControlLabel
                      control={<Checkbox checked={allMachinesSelected} onChange={onSelectAllMachineChange}
                                         color="primary"></Checkbox>}
                      label={t('Machine.Contacts.AddContacts.SelectAllMachines')}/>
                  </Grid>}
                  actions={(machine: Machine) => <Checkbox color="primary" checked={props.selectedMachines.some(x => machine.id === x.id)} onChange={(e) => {onSelectMachine(machine, e);}}></Checkbox>}/>
    </Fragment>
}

export default SelectMachines;
